export default {
    data(){
        return {
            
        }
    },
    props: {
        params: {
            type: Object
        },
        render: {
            type: Function
        }
    },
    render(h) {
        return this.render(h, this.params)
    }
}
  


// WEBPACK FOOTER //
// ./src/assets/js/renderProps.js